import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { ReservesRepository } from "../Repositories/reserves.repository";
import { ReservesFilter } from "../Types/Interfaces/reserves-filter.interface";
import { Reserves, ReservesDetail } from "../Types/Interfaces/reserves.interface";

@Injectable({
  providedIn: "root",
})
export class ReservesService {
  constructor(private reservesRepository: ReservesRepository, private fileHandlerService: FileHandlerService) {}
  public getReservesPolicies(): Observable<DropdownOption[]> {
    return this.reservesRepository.getReservesPolicies();
  }

  public getAccountTypes(): Observable<DropdownOption[]> {
    return this.reservesRepository.getAccountTypes();
  }

  public getReserves(reservesFilter: ReservesFilter, spinner = true): Observable<Reserves> {
    return this.reservesRepository.getReserves(reservesFilter, spinner);
  }

  public getReservesDetail(accountCode: string): Observable<ReservesDetail[]> {
    return this.reservesRepository.getReservesDetail(accountCode);
  }

  public getReservesReport(account: string, companyCode: string, startDate: Date, endDate: Date): void {
    this.reservesRepository
      .getReservesReport(account, companyCode, startDate, endDate)
      .pipe(first())
      .subscribe((report) => {
        this.fileHandlerService.openPdfInNewTab(report);
      });
  }
}
